/* @file FuelMeter.jsx
* @exports FuelMeter
*/
import React from 'react'

const FuelMeter = function FuelMeter () {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='57' height='43' fill='none' viewBox='0 0 57 43'>
      <path fill='#284047' d='M7.3 9.4h3.4v1.1H8.5v1h1.8v1.1H8.5v1.2h2.2V15H7.2l.1-5.6s-.1 0 0 0zM24.6 39.2c0 1.4.8 2.6 1.9 3.1.5.2 1 .3 1.5.3 1.7.1 3.3-1.2 3.5-3.1.1-.9-.1-1.7-.6-2.4l14.6-19.8c.3-.5.3-1.1-.2-1.5-.5-.3-1.1-.3-1.5.2L29.4 35.9c-.3-.1-.5-.1-.8-.1h-.4c-.4 0-.8.1-1.2.2-1.4.4-2.4 1.7-2.4 3.2zm4.7-.8c.2.3.3.6.3 1-.1.7-.7 1.2-1.4 1.2H28c-.8-.1-1.3-.8-1.2-1.5.1-.7.7-1.2 1.4-1.2h.1c.5 0 .7.2 1 .5z' />
      <path fill='#284047' d='M55.7 11.4C48.4 4.1 38.5 0 28.1 0h-.3C17.4.1 7.7 4.2.3 11.4c-.4.4-.4 1 0 1.5l7.4 7.4c.4.4 1 .4 1.5 0 .4-.4.9-.8 1.4-1.2.7-.6 2-1.7 3.4-2.6 1.4-.9 2.9-1.6 4.5-2.2 3-1.2 6.2-1.8 9.4-1.9h.3c5.2 0 10.2 1.5 14.4 4.3l.7-1c.6-.8 1.6-.9 2.4-.3.8.6.9 1.6.3 2.4l-.7 1c.6.5 1.1 1 1.7 1.5.4.4 1 .4 1.5 0l7.4-7.4c.3-.3.3-1-.2-1.5zm-13.2 2.9c-4.4-2.6-9.3-3.9-14.4-3.9h-.3c-3.6 0-7.1.7-10.4 2-1.6.7-3.2 1.5-4.7 2.4-.7.4-2.5 1.8-3.3 2.5-.3.3-.6.5-.8.8l-5.9-5.9c6.7-6.4 15.6-10 25-10.1h.3c6.6 0 13 1.7 18.6 5l-4.1 7.2zm8-3.7h-2.1v1.2h1.9v1.1h-1.9V15h-1.3V9.6h3.5v1h-.1z' />
    </svg>
  )
}

export default FuelMeter
